'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pt_PT = require('../locale/pt_PT');

var _pt_PT2 = _interopRequireDefault(_pt_PT);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _pt_PT2['default'];